import React from "react";
import { Box } from "@mui/material";
import ViolationComments from "./ViolationComments"; // Adjust path if needed

const ViolationCommentsTab = ({ violation_id, currentUserId }) => {
  return (
    <Box>
      <ViolationComments
        violation_id={violation_id}
        currentUserId={currentUserId}
      />
    </Box>
  );
};

export default ViolationCommentsTab;
